export default "__VITE_ASSET__zbav8B2f__"